<div
  class="sidebar d-none d-lg-block"
  [ngClass]="{ 'sidebar-hidden': !isSidebarVisible }"
>
  <div class="sidebar-inside">
    <div>
      <a
        href="javascript:void(0)"
        class="sidebar-links-item-link collapse-btn"
        (click)="toggleSidebar()"
      >
        <span class="sidebar-links-item-icon">
          <i class="fas fa-arrow-circle-left"></i>
        </span>
        <span class="sidebar-links-item-text">quick links</span>
      </a>

      <ul class="sidebar-links">
        <ng-container *ngFor="let item of sidebarItems">
          <li
            *ngxPermissionsOnly="
              item.avilableFor !== undefined ? item.avilableFor : []
            "
          >
            <div
              class="sidebar-links-item"
              [class.has-menu]="item.subMenu"
              [class.menu-shown]="item.isCollapsed"
            >
              <a
                [routerLink]="['/dashboard', item.path]"
                routerLinkActive="active"
                class="sidebar-links-item-link"
                [title]="!isSidebarVisible ? item.title : ''"
              >
                <span class="sidebar-links-item-icon">
                  <i class="fas {{ item.icon }}"></i>
                </span>
                <span class="sidebar-links-item-text">{{ item.title }}</span>
              </a>

              <button
                type="button"
                *ngIf="item.subMenu?.length"
                class="sidebar-links-item-submenu-btn"
                (click)="toggleSubMenu(item)"
                [attr.aria-expanded]="!item.isCollapsed"
                aria-controls="collapseExample"
              >
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>

            <div
              class="sidebar-submenu"
              *ngIf="item.subMenu"
              [@smoothCollapse]="item.isCollapsed ? 'open' : 'close'"
            >
              <ng-container *ngFor="let subItem of item.subMenu">
                <ng-container
                  *ngxPermissionsOnly="
                    subItem.avilableFor !== undefined ? subItem.avilableFor : []
                  "
                >
                  <a
                    [routerLink]="['/dashboard', subItem.path]"
                    routerLinkActive="active"
                    (isActiveChange)="onRouterLinkActive(item)"
                    class="sidebar-links-item-link"
                    [title]="!isSidebarVisible ? subItem.title : ''"
                  >
                    <span class="sidebar-links-item-icon">
                      <i class="fas {{ subItem.icon }}"></i>
                    </span>
                    <span class="sidebar-links-item-text">{{
                      subItem.title
                    }}</span>
                  </a>
                </ng-container>
              </ng-container>
            </div>
          </li>
        </ng-container>
      </ul>
      <div
        style="width: 100%; text-align: center; color: white; padding-top: 40px"
      >
        v3.11.00
      </div>
    </div>
  </div>
</div>
